var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellArrowSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9944 10.8742C19.9944 10.4167 19.6244 10.0442 19.166 10.0417L12.5052 10H12.5002C12.0419 10 11.6702 10.37 11.6669 10.8283C11.6635 11.2883 12.0344 11.6642 12.4952 11.6667L17.1269 11.6958L10.2444 18.5775C9.91854 18.9033 9.91854 19.4308 10.2444 19.7558C10.4069 19.9192 10.6202 20 10.8335 20C11.0469 20 11.2602 19.9192 11.4227 19.7558L18.3294 12.8492L18.3335 17.5008C18.3335 17.9608 18.7069 18.3333 19.1669 18.3333H19.1677C19.6277 18.3333 20.0002 17.9592 20.0002 17.4992L19.9944 10.8742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellArrowSquare);
export default __webpack_public_path__ + "static/media/sell-arrow-square.1de74779f833491e3b6226cfe5e64074.svg";
export { ForwardRef as ReactComponent };